module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAFBJREFUSA1jYBgFoyEwGgLDMAT+///vCcSPgfgRiA3zIqniMH0YNNRwIAUGj2AKgDyQpTBAUBymjwnGoBsNdCJtg4huPhm1aDQERkOAeiEAAH7dhOrihGFVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/other_w.png
// module id = vrts
// module chunks = 2